module.exports = __webpack_public_path__ + "img/engineering.ee2d09b0.svg";